import EditorServices from './services';
export default function(data) {
  var self = this;
  self.element = $('#guest_lecturers');
  self.lecturers = ko.observableArray();
  self.server_errors = ko.observableArray();
  self.current_user = ko.observable();
  self.new_lecturer = function() {
    var self = this;
    self.id = ko.observable();
    self.first_name = ko.observable('');
    self.last_name = ko.observable('');
    self.avatar = {
      'url': ko.observable(),
      'thumb': {
        'url': ko.observable()
      },
      'gray_thumb': {
        'url': ko.observable()
      }
    };

    self.bio = ko.observable().extend({required: true, maxLength: 1500, rateLimit: { timeout: 1000, method: 'notifyWhenChangesStop' }});
    self.course_id = ko.observable();
    self.email = ko.observable('');
    self.full_name = ko.computed(function() {
      return self.first_name() + ' ' + self.last_name();
    });
    self.social_info = {
      'website': ko.observable(),
      'facebook': ko.observable(),
      'twitter': ko.observable(),
      'vimeo': ko.observable(),
      'soundcloud': ko.observable(),
      'pinterest': ko.observable(),
      'tumblr': ko.observable(),
      'linkedin': ko.observable(),
      'youtube': ko.observable()
    };
    self.guest_lecturer_titles = ko.observableArray();
    self.guest_lecturer_titles.push({
      'title': ko.observable(''),
      'organization': ko.observable(''),
      'guest_lecturer_id': ko.observable()
    });
  };

  self.warnLength = function(data) {
    // if(data.bio()) {
    //   if(data.bio().length > 1499 || data.bio.length > 1499) {
    //     new Kadenze.Notice.error({ message: 'Character limit of 1500' });
    //   }
    // }
  };

  self.initUI = function() {
    EditorServices.initDropZones(self.element, self.lecturers);
  };

  self.bindData = function(data) {
    self.lecturers = ko.mapping.fromJSON(data[0]);
    self.current_user = ko.mapping.fromJSON(data[1]);
  };

  self.addLecturer = function(item, event) {
    var newLecturer = new self.new_lecturer();
    self.removeStubs();
    self.lecturers.push(newLecturer);
    EditorServices.showLastEditor($(event.target).parent());
  };

  self.removeStubs = function() {
    ko.utils.arrayForEach(self.lecturers(), function(item) {
      if (typeof item == 'undefined' || typeof item.id() == 'undefined') {
        self.lecturers.remove(item);
      }
    });
  };

  self.editLecturer = function(item, event) {
    self.server_errors([]);
    EditorServices.showEditor($(event.target));
  };

  self.saveLecturer = function(item, event) {
    var index = self.lecturers().indexOf(item);
    var model = ko.toJS(item);
    var $target = $(event.currentTarget);
    var $editor = $target.parent().parent();

    model.guest_lecturer_titles_attributes = model.guest_lecturer_titles;
    model.social_info_attributes = model.social_info;
    delete model.guest_lecturer_titles;
    delete model.social_info;
    // model.guest_lecturer_titles_attributes = _.filter(model.guest_lecturer_titles_attributes, function(item) {
    //     item.title.trim() != "";
    // })

    var data = {guest_lecturer: model};
    var id = item.id() ? item.id() : '';
    var url = window.location.pathname.replace('instructors','guest_lecturers') + '/' + id;
    var method = item.id() ? 'PUT' : 'POST';

    var bioElement = $('.quill-editor-guest-bio-' + item.id()).find('.ql-editor');
    var isBioEmpty = bioElement.text() === '';

    self.client_errors = ko.validation.group(self.lecturers()[index], { deep: true });

    if (self.client_errors().length === 0 && (!isBioEmpty)) {
      var $image = $editor.find('div.dz-profile-img');
      var dz = Dropzone.forElement('#' + $image.attr('id'));
      var queuedFiles = dz.getQueuedFiles();
      //If drop zone has a queued file, send rest of the data along with it
      //else send it as usual
      if(queuedFiles.length > 0) {
        dz.on('sending', function(file, xhr, formData) {
          delete model.id;
          delete model.avatar;
          delete model.course_id;
          Kadenze.UIUtil.prepareFormData(formData, 'guest_lecturer', model);
          Kadenze.UIUtil.showLoadingIndicator($editor);
        });
        dz.on('success', function(file, response) {
          $editor.hide();
          self.lecturers().push(ko.mapping.fromJS(response));
          self.removeStubs();
        });
        dz.processQueue();
      } else {
        Kadenze.UIUtil.makeRequest(url, method, data, $editor, null, function(data) {
          EditorServices.hideEditor($target);
          self.server_errors([]);
          var lecturer = ko.mapping.fromJS(data);
          EditorServices.updateCollection(self.lecturers, lecturer);
          self.removeStubs();
        }, function(data) {
          self.server_errors(data.responseJSON.guest_lecturers);
        });
      }
    } else {
      if(isBioEmpty) {
        $('.quill-required-error').removeClass('hide');
        bioElement.addClass('ql-missing-field-error');
      }

      self.client_errors.showAllMessages();
    }
  };

  self.deleteLecturer = function(item, event) {
    var $target = $(event.currentTarget);
    var $editor = $target.parent().parent();
    var data = null;
    var id = item.id();
    var url = window.location.pathname.replace('instructors','guest_lecturers') + '/' + id;
    var method = 'DELETE';
    var deletePrompt = 'Are you sure you want to remove ' + item.full_name() + ' from guests of this course?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {
      if (item.id()){
        Kadenze.UIUtil.makeRequest(url, method, data, $editor, null, function(data) {
          EditorServices.hideEditor($target);
          self.server_errors([]);
          self.lecturers.remove(item);
        }, function(data) {
          self.server_errors(data.responseJSON.guest_lecturers);
        });
      } else {
        self.lecturers.remove(item);
      }
    });
  };

  const __construct = function(that) {
    console.log('constructor called for CourseGuestLecturerEditViewModel');
    that.bindData(data);
  }(this);
}
